__turbopack_context__.v({
  "container": "_1SGnyW_container",
  "dateText": "_1SGnyW_dateText",
  "dateWithIcon": "_1SGnyW_dateWithIcon",
  "executionBoard": "_1SGnyW_executionBoard",
  "executionBoardActions": "_1SGnyW_executionBoardActions",
  "locationDateCell": "_1SGnyW_locationDateCell",
  "progressInfo": "_1SGnyW_progressInfo",
  "table": "_1SGnyW_table",
});
